export default __webpack_public_path__ + "static/media/view3_week_age_sex.4e4796e4.csv";